import * as React from 'react'
// Import from a CSS file in your src
import * as style from "./../components/industryLeader.module.css"

const IndustryLeader = (props) => {
  return (
<div className={[style.industryLeaderBackground + " lazyload"]}>
    <div className="container d-flex h-100 align-items-center p-5">
        <div className="row">
            <div className="col-12 col-md-7 offset-md-5">
                <div className="mx-auto text-center pt-5 pb-5">
                    <h3 className="mt-5">
                        A trusted name in cutting-edge practice management systems for more than 40 years.
                    </h3>
                    <p className="font-italic text-center">
                        {props.quote}<br />
                        <span className="ml-2 small">- { props.name }, { props.location }</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default IndustryLeader